import { render } from "./MiniWallet.vue?vue&type=template&id=24f74719&scoped=true"
import script from "./MiniWallet.vue?vue&type=script&lang=js"
export * from "./MiniWallet.vue?vue&type=script&lang=js"

import "./MiniWallet.vue?vue&type=style&index=0&id=24f74719&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f74719"]])

export default __exports__